export const LpFarmEvents = {
  GetStakedArmor: 'LpFarm.GetStakedArmor',
  StakedArmorReturned: 'LpFarm.StakedArmorReturned',

  GetOwnedArmor: 'LpFarm.GetOwnedArmor',
  OwnedArmorReturned: 'LpFarm.OwnedArmorReturned',

  GetRewardsOwed: 'LpFarm.GetRewardsOwed',
  RewardsOwedReturned: 'LpFarm.RewardsOwedReturned',

  GetRewardsGiven: 'LpFarm.GetRewardsGiven',
  RewardsGivenReturned: 'LpFarm.RewardsGivenReturned',

  GetTotalRewardsGiven: 'LpFarm.GetTotalRewardsGiven',
  TotalRewardsGivenReturned: 'LpFarm.TotalRewardsGivenReturned',

  GetTotalStakers: 'LpFarm.GetTotalStakers',
  TotalStakersReturned: 'LpFarm.TotalStakersReturned',

  Stake: 'LpFarm.Stake',
  StakeCompleted: 'LpFarm.StakeCompleted',

  ClaimRewards: 'LpFarm.ClaimRewards',
  ClaimRewardsCompleted: 'LpFarm.ClaimRewardsCompleted',

  Withdraw: 'LpFarm.Withdraw',
  WithdrawCompleted: 'LpFarm.WithdrawCompleted',

  Exit: 'LpFarm.Exit',
  ExitCompleted: 'LpFarm.ExitCompleted',
}
